import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-retirement-healthcare-costs',
  templateUrl: './retirement-healthcare-costs.component.html',
  styleUrls: ['./retirement-healthcare-costs.component.scss']
})
export class RetirementHealthcareCostsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<RetirementHealthcareCostsComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
